import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { campaignInfo } from 'src/app/modules/campaign/campaign';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-list-campaigns',
  templateUrl: './list-campaigns.component.html',
  styleUrls: ['./list-campaigns.component.css']
})
export class ListCampaignsComponent implements OnInit {

  public campaignData = campaignInfo;
  public employeeData = {};
  public pickupPointData = {};
  public userData;
  public routeData = [];

  constructor( public router: Router,
    public api: ApiService,
    public swal: SweetAlert,
    private comservice: CommonServices,
    public storage: StorageService,){
      this.userData = this.storage.get('userInfo')
     }

  ngOnInit(): void {
    this.getRouteData();
    this.setEmployees();
  }
  getPickupList(route) {
    let obj = {
      orgID:route.orgID,
      routeID:route.routeID,
    };

    this.api.listRoutePickupPoint(obj).then((res:any)=>{
      if(res.status =='success'){

         this.pickupPointData[route.routeID] = res.data[0].pickupInfo;
         this.pickupPointData[route.routeID].map((item)=>{
               item.eta = (''+item.eta).replace('.',':');
               return item;
         });
         console.log('inside pickup point',this.pickupPointData);
     }
    });
  }
  getRouteData(){
    //  this.api.transportMangerRouteList
    this.api.transportMangerRouteList({}).then((res:any)=>{
         if(res.status == 'success'){
          this.routeData = res.data.map((item:any)=>{
                 return {
                      title: item.title,
                      trasitMode: item.trasitMode,
                      attendence: typeof item.attendence == 'string' ? item.attendence: item.attendence.join(','),
                      startTime: (''+item.startTime).replace(".",":"),
                      endTime: (''+item.endTime).replace(".",":"),
                      routeType: item.routeType,
                      keywords: item.keywords,
                      holidayPattern: item.holidayPattern,
                      orgID : item.orgID,
                      routeID: item.routeID,
                      status: item.status,
                      fromDate : this.comservice.timestampToDate(item.fromDate,'DMY','-'),
                      vehicle: item.vehicle
                    };
               });
         }
    });
  }

  setEmployees(){
    this.campaignData.filter((campaign)=>{
      if (campaign['routeInfo'][0] == "allRoutes"){
        console.log('all routes');
        
        this.routeData.filter((route)=>{
          this.getPickupList(route);
          setTimeout(()=>{
            this.pickupPointData[route.routeID].filter((pickups)=>{
              console.log(pickups);
            })

          },500);
        });


      }
      else {
        console.log(campaign['routeInfo'],typeof(campaign.routeInfo));
        let routes = campaign.routeInfo
        /*   campaign['routeInfo'].filter((route)=>{
          this.getPickupList(route);
          setTimeout(()=>{
  
          if(route.checked){
              this.employeeData[route.routeID] = [];
              console.log('inside pickupoint filter',this.pickupPointData);
              this.pickupPointData[route.routeID].filter((pickupPoint)=>{
                if (pickupPoint.employees && pickupPoint.employees.length > 0)
                  this.employeeData[route.routeID].push(pickupPoint.employees);
              })
              
            }
          else if(route.indeterminate){
            
            route['vehicleInfo'].filter((vehicle)=>{
             
              vehicle['pickupInfo'].filter((pickupPoint)=>{
                this.pickupPointData[route.routeID].filter((pickups)=>{
                  if(pickups.location == pickupPoint.location){
                    console.log(pickupPoint.employees);
                  }
                })              
              });
            });
            
          }
          
        },500);
  
        }); */
      }
    });
    console.log(this.employeeData,this.pickupPointData);
  }
  public showTitleFilter:boolean = false;
  public showFilter:boolean = false;
}
